import { createSlice } from "@reduxjs/toolkit";

export interface ConfirmPasswordChangeSliceState {
  showToast: boolean;
  toastMessage: string;
  toastType: "success" | "error";
}

const initialState: ConfirmPasswordChangeSliceState = {
  showToast: false,
  toastMessage: "",
  toastType: "success",
};

export const confirmPasswordChangeSlice = createSlice({
  name: "confirmPasswordChangeSlice",
  initialState,
  reducers: {
    showPasswordChangeToast: (state, action) => {
      state.showToast = true;
      if (typeof action.payload == "string") {
        state.toastMessage = action.payload;
        state.toastType = "success";
      } else {
        state.toastMessage = action.payload.message;
        state.toastType = action.payload.type;
      }

      return state;
    },
    hidePasswordChangeToast: (state) => {
      state.showToast = false;
      state.toastMessage = "";
      state.toastType = "success";

      return state;
    },
  },
});

export const { showPasswordChangeToast, hidePasswordChangeToast } = confirmPasswordChangeSlice.actions;
export default confirmPasswordChangeSlice;
